<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role != 'account'">
            <div class="page-header">
                <h3 class="page-title">Отчёт по медиабайерам</h3>
            </div>
            <div class="row mb-2">
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select :options="isTestOptions"
                              :searchable="false"
                              :clearable="false"
                              v-model="isTest"
                              placeholder="Тест">
                    </v-select>
                </div>
                <div :key="dateRange" class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-button-group v-if="isXl" class="datePickerXl ">
                        <date-range-picker
                                ref="picker"
                                :locale-data="dateRangeLocalFormat"
                                v-model="range"
                                :opens="'right'"
                                :ranges="dateRanges"
                                @update="selectRange($event)">
                            <template v-slot:input="picker" style="min-width: 350px;!important;">
                                {{ range.startDate | formatDateRange }} - {{ range.endDate | formatDateRange  }}
                            </template>
                        </date-range-picker>
                        <b-button size="sm" variant="primary">
                            <i class="icon-fa icon-fa-calendar-check-o"></i>
                        </b-button>
                    </b-button-group>
                    <b-input-group :key="dateRange" v-if="!isXl">
                        <div></div>
                        <b-input-group-append>
                            <datepicker input-class="form-control dateFrom"
                                        class="date dateLeft"
                                        size="sm"
                                        monday-first
                                        v-model="range.startDate"
                                        :language="ru"
                                        placeholder="С:">
                            </datepicker>
                            <datepicker input-class="form-control dateTo"
                                        class="date dateRight"
                                        size="sm"
                                        monday-first
                                        v-model="range.endDate"
                                        :language="ru"
                                        placeholder="По:">
                            </datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select :options="selectOffers" :filter="filterOffers" required label="title" v-model="search"
                              placeholder="Оффер"

                              multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                        <template slot="option" slot-scope="option">
                            <span>({{option.id}}) {{ option.title }}</span>
                        </template>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select :options="sources" required

                              label="title" v-model="source" placeholder="Источник"
                              multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select :options="groups" required

                              v-model="group" placeholder="Группа" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2"
                     v-if="$currentUser.role == 'admin' || $currentUser.role == 'leader'">
                    <v-select label="name" :options="users"

                              required v-model="user" placeholder="Медиабайер" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2"
                     v-if="this.$currentUser.department === 'adkey'">
                  <v-select :options="applicationOwnerOptions"
                            placeholder="Приложение"
                            :clearable="false"
                            :searchable="false"
                            v-model="application_owner">
                  </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select :options="types"
                              placeholder="Тип"
                              :clearable="false"
                              :searchable="false"
                              multiple
                              v-model="type">
                    </v-select>
                </div>
              <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <v-select :options="sub4Options"
                          placeholder="Subid-4"
                          label="text"
                          :clearable="false"
                          :searchable="false"
                          v-model="selectedSub4">
                </v-select>
              </div>
              <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <v-select :options="userGroups"
                          label="title"
                          placeholder="Группа пользователей"
                          :clearable="false"
                          :searchable="false"
                          :reduce="userGroup => userGroup.id"
                          multiple
                          v-model="selectedUserGroups">
                </v-select>
              </div>
              <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                <v-select label="name"
                          class="geoComponent"
                          :options="geo" size="sm" required v-model="selectedGeo" placeholder="ГЕО"
                          multiple>
                  <span slot="no-options">Совпадений не найдено.</span>
                </v-select>
              </div>
            </div>
            <div class="row mt-2">
                <div class="col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton">
                    <b-input-group>
                        <div></div>
                        <b-input-group-append>
                            <b-btn size="sm" text="Search" variant="success"
                                   class="mainButton"
                                   style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                                   @click="getReports(1, {sortBy: sortBy, sortDesc: sortDesc}, user, search, true)">
                                Применить
                                <!--<i class="icon-fa icon-fa-search"></i>-->
                            </b-btn>
                            <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">Очистить
                                <!--<i class="icon-fa icon-fa-times"></i>-->
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-sm-2 col-md-6 col-lg-6 col-xl-8 mb-2 "></div>
                <div class="col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton">
                    <b-button-group class="float-right  mainButton">
                        <a class="btn btn-outline-success btn-sm"
                           v-bind:href="getExcelParamsString('xlsx')">Excel</a>
                        <a class="btn btn-outline-success btn-sm"
                           v-bind:href="getExcelParamsString('csv')">CSV</a>
                    </b-button-group>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-if="!isMobile">
                        <b-table hover responsive bordered
                                 small
                                 :items="reports"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getReports(1, $event,user, search)"
                                 :busy="isBusy"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template slot="table-busy">
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Загрузка...</strong>
                                </div>
                            </template>
                            <template slot="roi" slot-scope="row">
                                <div v-if="row.item.roi !== null">{{row.item.roi}}</div>
                                <div v-if="row.item.roi === null">0.00</div>
                            </template>
                            <template slot="gm_rev" slot-scope="row">
                                <div v-if="row.item.gm_rev !== null">{{row.item.gm_rev}}</div>
                                <div v-if="row.item.gm_rev === null">0.00</div>
                            </template>
                        </b-table>
                    </div>
                    <div v-if="isMobile">
                        <b-table hover responsive bordered stacked
                                 small
                                 :items="reports"
                                 :busy="isBusy"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getReports(1, $event,user, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template slot="table-busy">
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Загрузка...</strong>
                                </div>
                            </template>
                            <template slot="roi" slot-scope="row">
                                <div v-if="row.item.roi !== null">{{row.item.roi}}</div>
                                <div v-if="row.item.roi === null">0.00</div>
                            </template>
                            <template slot="gm_rev" slot-scope="row">
                                <div v-if="row.item.gm_rev !== null">{{row.item.gm_rev}}</div>
                                <div v-if="row.item.gm_rev === null">0.00</div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-sm-6">
                    <div class="" role="status" aria-live="polite">Количество строк:
                        <b-form-select v-model="pageSize"
                                       style="width: 70px;"
                                       v-on:change="getReports()"
                                       size="sm">
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="75">75</option>
                            <option :value="100">100</option>
                            <option :value="150">150</option>
                            <option :value="200">200</option>
                        </b-form-select>
                    </div>
                    <div class="" role="status" aria-live="polite">Записей на странице: <span
                            v-if="reports && reports.length">{{ reports.length - 2 }}</span><span
                            v-if="!reports">0</span>
                    </div>
                    <div class="" role="status" aria-live="polite">Всего записей: <span v-if="pager && pager.total">{{ pager.total }}</span><span
                            v-if="!pager || !pager.total">0</span></div>
                </div>
                <div class="col-sm-6">
                    <div class="float-right">
                        <nav aria-label="Page navigation">
                            <ul class="pagination justify-content-center">
                                <b-pagination size="sm" :total-rows="pager.total"
                                              v-model="pager.current_page"
                                              v-on:change="getReports($event, {sortBy: sortBy, sortDesc: sortDesc},user, search)"
                                              :per-page="pager.per_page"></b-pagination>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import OffersService from '../../services/offersDataService'
    import SourcesService from '../../services/sourcesDataService'
    import ReportsService from '../../services/reportsDataService'
    import Ls from '../../services/ls'
    import {ru} from '../../services/customLocaleDatepicker'
    import Datepicker from 'vuejs-datepicker'
    import reportMixin from "./mixins/reportMixin";
    import saveFiltersMixin from "./mixins/saveFiltersMixin";
    import DateRangePicker from 'vue2-daterange-picker'

    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import vue2DateRangePickerMixin from "./mixins/vue2DateRangePickerMixin";
    import dataOptionsMixin from "./mixins/dataOptionsMixin";
    import UsersService from "../../services/usersDataService";

    export default {
        name: 'usersReportComponent',
        components: {
            Datepicker: Datepicker,
            DateRangePicker: DateRangePicker
        },
        mixins: [
            reportMixin,
            saveFiltersMixin,
            vue2DateRangePickerMixin,
            dataOptionsMixin
        ],
        data() {
            return {
                isBusy: true,
                sources: [],
                group: [],
                pager: {},
                source: [],
                user: this.$currentUser.role == 'leader' ? [this.$currentUser] : null,
                users: [],
                reports: [],
                groups: [],
                userGroups: [],
                selectedUserGroups: [],
                selectedGeo: [],
                geo: [],
                fields: [
                    {
                        key: 'user_name',
                        label: 'Медиабайер',
                        sortable: true
                    },
                    {
                        key: 'expense_with_discount_usd',
                        label: 'Расход,$',
                        sortable: true
                    },
                    {
                        key: 'revenue_usd',
                        label: 'Доход,$',
                        sortable: true
                    },
                    {
                        key: 'profit',
                        label: 'Прибыль,$',
                        sortable: true
                    },
                    {
                        key: 'roi',
                        label: 'ROI,%',
                        sortable: true
                    },
                    {
                        key: 'gm_rev',
                        label: 'GM/REV,%',
                        sortable: true
                    },
                ],
                search: '',
                sortBy: 'user_name',
                sortDesc: true,
                sortDirection: 'desc',
                pageSize: 25,
                selectedSub4: '',
                range: {
                    startDate: null,
                    endDate: null
                },
                isTestOptions: [
                    {value: 0, label: 'Не тест'},
                    {value: 1, label: 'Тест'},
                    {value: null, label: 'Все данные'},
                ],
                isTest: {value: 0, label: 'Не тест'},
                dateRange: 0,
                selectedSource: null,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                selectOffers: [],
                isXl: false,
                ru: ru,
                savedFiltersName: 'users-report',
            }
        },
        methods: {
            filterOffers(options, search) {
                if (search) {
                    return options.filter(option => {
                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 || option.id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
            getOffersForSelect() {
                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }
                let user = null;

                OffersService.getOffers(1, sort, null, range, user, true)
                    .then(function (response) {
                        this.selectOffers = response;

                    }.bind(this))
            },
            getReports(page, sort, user, search, isFilter) {
                if (this.useSavedFilters == true) {
                    let filters = this.getFilters(this.savedFiltersName)

                    if (filters) {
                        page = filters.page
                        sort = filters.sort
                        user = filters.user
                        search = filters.search

                        this.passFilters(filters)
                    }
                }
                if (isFilter) {
                    this.isBusy = true;
                }
                if (!page) {
                    page = 1;
                }

                if (!sort) {
                    sort = this;
                }

                let userArray = [];

                if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                    if (this.user && this.user.length != 0) {
                        this.user.forEach(function (userItem) {
                            userArray.push(userItem.id)
                        });
                    } else {
                        userArray.push('all')
                    }
                }

                if (this.$currentUser.role == 'user') {
                    userArray.push(this.$currentUser.id);
                }

                let sourceArray = [];

                if (this.source && this.source.length != 0) {
                    this.source.forEach(function (sourceItem) {
                        sourceArray.push(sourceItem.id)
                    });
                } else {
                    sourceArray.push('all')
                }

                if (!search) {
                    search = this.search;
                }

                let searchArray = [];

                if (search.length > 0) {
                    search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substring(0, 10),
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substring(0, 10)
                };

                let filtersObject = this.prepareFiltersObject(page, sort, search, user)

                this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

                ReportsService.getUsersReport(page, sort, searchArray, range, userArray, this.pageSize, this.group, sourceArray, this.getCurrentOfferTypes(), this.isTest.value, this.application_owner.value, this.selectedSub4, this.selectedUserGroups, this.selectedGeo)
                    .then(function (response) {
                        this.useSavedFilters = false
                        this.pager = response.reports;
                        this.reports = response.reports.data

                        if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                            let sumValues = ReportsService.getSumValues(this.reports)

                            let customRaw = {
                                user_name: 'Итого по странице:',
                                expense_with_discount_usd: sumValues.sumExpenseWithDiscountUsd,
                                revenue_usd: sumValues.sumRevenueUsd,
                                profit: sumValues.sumProfit,
                                roi: sumValues.sumRoi,
                                gm_rev: sumValues.sumGmRev,
                                _rowVariant: 'secondary'
                            };

                            let customSecondRaw = {
                                user_name: 'Итого:',
                                expense_with_discount_usd: response.sumValues.length > 0 && response.sumValues[0].expense_with_discount_usd ? response.sumValues[0].expense_with_discount_usd : 0.00,
                                revenue_usd: response.sumValues.length > 0 && response.sumValues[0].revenue_usd ? response.sumValues[0].revenue_usd : 0.00,
                                profit: response.sumValues.length > 0 && response.sumValues[0].profit ? response.sumValues[0].profit : 0.00,
                                roi: response.sumValues.length > 0 && response.sumValues[0].roi ? response.sumValues[0].roi : 0.00,
                                gm_rev: response.sumValues.length > 0 && response.sumValues[0].gm_rev ? response.sumValues[0].gm_rev : 0.00,
                                _rowVariant: 'secondary'
                            };

                            this.reports.push(customRaw)
                            this.reports.push(customSecondRaw)
                        }
                        this.isBusy = false;
                    }.bind(this))
            },
            prepareFiltersObject(page, sort, search, user) {
                let object = {
                    page: page,
                    sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
                    search: search,
                    type: this.type,
                    pageSize: this.pageSize,
                    range: this.range,
                    group: this.group,
                    user: user ? user : this.user,
                    source: this.source,
                    isTest: this.isTest,
                    application_owner: this.application_owner,
                    selectedUserGroups: this.selectedUserGroups,
                    selectedGeo: this.selectedGeo
                }

                return object;
            },
            passFilters(filters) {
                this.range = this.dateConvert(filters.range.startDate, filters.range.endDate)
                this.search = filters.search
                this.type = filters.type
                this.pageSize = filters.pageSize
                this.group = filters.group
                this.source = filters.source
                this.isTest = filters.isTest
                this.application_owner = filters.application_owner
                this.user = filters.user
                this.selectedUserGroups = filters.selectedUserGroups
                this.selectedGeo = filters.selectedGeo
            },
            selectRange(event) {
                this.range = event;
            },
            resetFilters() {
                this.search = '';
                this.user = this.$currentUser.role == 'leader' ? [this.$currentUser] : null;
                this.source = null;
                this.group = null;
                this.isTest = {value: 0, label: 'Не тест'};

                this.range = {
                    startDate: null,
                    endDate: null
                };
                this.type = []
                this.application_owner = Object.assign({}, this.applicationOwnerOptions[this.application_owner_default_option_idx])

              //re-initialize element
                this.dateRange++;
                this.selectedUserGroups = []
                this.selectedGeo = []

                this.getReports();
            },
            getUsers() {
                OffersService.getUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            getLeaderUsers() {
                OffersService.getLeaderUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            getCountries() {
              OffersService.getCountries()
                .then(function (response) {
                  let countries = [];

                  response.forEach(function (item) {
                    countries.push(item.code);
                  });

                  this.geo = countries;
                }.bind(this))
            },
            getSources() {
                ReportsService.getSourcesForSelect()
                    .then(function (response) {
                        this.sources = response
                    }.bind(this))
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
            getUserGroups() {
              let sort = {
                sortBy: null,
                sortDesc: null
              }

              UsersService.getUserGroups(sort)
                .then(userGroups => {
                  this.userGroups = userGroups;
                })
            },
            getExcelParamsString(format) {
                let userArray = [];

                if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                    if (this.user && this.user.length != 0) {
                        this.user.forEach(function (userItem) {
                            userArray.push(userItem.id)
                        });
                    } else {
                        userArray.push('all')
                    }
                }

                if (this.$currentUser.role == 'user') {
                    userArray.push(this.$currentUser.id);
                }

                let sourceArray = [];

                if (this.source && this.source.length != 0) {
                    this.source.forEach(function (sourceItem) {
                        sourceArray.push(sourceItem.id)
                    });
                } else {
                    sourceArray.push('all')
                }

                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substring(0, 10),
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substring(0, 10)
                };

                let searchArray = [];

                if (this.search.length > 0) {
                    this.search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                format = format ? format : this.format

                let AUTH_TOKEN = Ls.get('auth.token')

                return '/reports/export?subject=users&sortBy=' + this.sortBy + '&sortDesc=' + this.sortDesc + '&start=' + range.startDate
                      + '&end=' + range.endDate + '&user=' + userArray + '&search=' + searchArray + '&group=' + this.group
                      + '&source=' + sourceArray + '&format=' + format + '&token=' + AUTH_TOKEN + '&isTest=' + this.isTest.value
                      + '&type=' + this.getCurrentOfferTypes() + '&selectedSub4=' + this.selectedSub4.value
                      + '&selectedUserGroups=' + this.selectedUserGroups + '&selectedGeo=' + this.selectedGeo;
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 415) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }


                if (this.window.width > 1199) {
                    this.isXl = true
                } else {
                    this.isXl = false
                }
            }
        },
        beforeMount() {
            this.useSavedFilters = true
            if (this.$currentUser.role == 'leader') {
                this.getLeaderUsers()
            } else if (this.$currentUser.role == 'admin') {
                this.getUsers()
            }
            this.getGroups();
            this.getSources();
            this.getReports();
            this.getOffersForSelect();
            this.getUserGroups();
            this.getCountries();
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }

    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
        height: 35px;
    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
        height: 35px;
    }

    .mainButton {
        width: 100%;
    }

    .date {
        width: 100%;
    }

    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    .input-group-append {
        width: 100%;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }

    .myOffers {
        padding-top: 4px;
    }

    .geoComponent .vs__search {
        margin: 2px 0 0;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    .reportrange-text {
        font-size: 0.9rem;
        min-width: 150px;
        width: 110%!important;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 1200px) {
        .myOffers {
            max-width: 14.66666667% !important;
        }

        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }

        .myOffers {
            max-width: 12.66666667% !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }

        .myOffers {
            max-width: 11.66666667% !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }

        .myOffers {
            max-width: 9.66666667% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/UsersReport.vue